// NOTA: Se hace V2 solo para aplicar mejoras en recepcionar Asn.
// Para los otros formularios que ocupaban el mismo componente habia que hacer modificaciones visuales que ya tenian que ser evaluadas, por lo que se hace este componente v2 sin afectar los demas. (realizar mejora en venta en verde o fefo)
import React from 'react'
import {
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid
} from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

interface CollapseButtonProps {
  header: any
  handleClick: any
  handleChangeProp?: any
  showButton?: boolean
  width?: string
  children?: React.ReactNode
}

export const CollapseButtonV2: React.FC<CollapseButtonProps> = ({
  header,
  children,
  handleClick,
  handleChangeProp,
  showButton = true
}) => {
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = () => {
    setExpanded((prev) => !prev)
  }

  return (
    <Grid
      container
      alignItems='stretch'
      spacing={0}
      sx={{ mt: '5px', width: '100%' }}
    >
      <Grid
        item
        xs={showButton && expanded ? 11 : 12}
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <Accordion
          expanded={expanded}
          onChange={() =>
            handleChangeProp ? handleChangeProp() : handleChange()
          }
          sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}
        >
          <AccordionSummary
            expandIcon={<ChevronRightIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
            sx={{
              backgroundColor: '#e2e8f0',
              flex: 1,
              '& .MuiAccordionSummary-expandIcon': {
                transform: 'rotate(0deg)',
                transition: 'transform 0.2s'
              },
              '& .MuiAccordionSummary-expandIcon.Mui-expanded': {
                transform: 'rotate(90deg)'
              }
            }}
          >
            <Typography variant='h6' component='span'>
              {header}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
      </Grid>

      {expanded && showButton && (
        <Grid item xs={1} sx={{ display: 'flex', alignItems: 'stretch' }}>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            onClick={handleClick}
            sx={{
              height: '100%',
              minWidth: '40px',
              padding: '0 1px',
              ml: '2px'
            }}
          >
            <ChevronRightIcon />
          </Button>
        </Grid>
      )}
    </Grid>
  )
}
